import api from './api';

export default {
  login({ email, password }) {
    return new Promise((resolve, reject) => {
      api
        .post(
          'oauth/token',
          {
            grant_type: 'password',
            client_id: process.env.VUE_APP_OAUTH_CLIENT_ID,
            client_secret: process.env.VUE_APP_OAUTH_CLIENT_SECRET,
            username: email,
            password,
            scope: ''
          },
          {
            baseURL: api.defaults.baseURL.replace('/api/', '/')
          }
        )
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },

  forgottenPassword({ email }) {
    return new Promise((resolve, reject) => {
      api
        .put('auth/forgotten-password', { email })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },

  resetPassword({ email, password, password_reset_token }) {
    return new Promise((resolve, reject) => {
      api
        .put('auth/reset-password', { email, password, password_reset_token })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },

  getProfile() {
    return new Promise((resolve, reject) => {
      api
        .get('me')
        .then(response => resolve(response.data.data))
        .catch(error => reject(error.data));
    });
  },

  addUser(user) {
    return new Promise((resolve, reject) => {
      api
        .post('user', { user })
        .then(response => resolve(response.data.data))
        .catch(error => reject(error.data));
    });
  },

  updateBusinessRole({ id, updates }) {
    return new Promise((resolve, reject) => {
      api
        .put(`user/${id}/business-roles`, {
          business_id: updates.business_id,
          attach: updates.attach
        })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },

  updateSecurityRole({ id, updates }) {
    return new Promise((resolve, reject) => {
      api
        .put(`user/${id}/security-roles`, {
          role: updates.role,
          attach: updates.attach
        })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },

  getUsersByRole({ role }) {
    let filters = {
      whereHas: [
        {
          relation: 'roles',
          filters: { where: [['name', '=', role]] }
        }
      ]
    };

    let params = {
      orderby: 'last_name',
      filters
    };

    return new Promise((resolve, reject) => {
      api
        .get('user', { params })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },

  async getUsersByBusiness({ businessId }) {
    let filters = {
      whereHas: [
        {
          relation: 'businesses',
          filters: { where: [['id', '=', businessId]] }
        }
      ]
    };

    let params = {
      orderby: 'last_name',
      filters
    };

    const res = await api.get('user', { params });
    return res.data.data;
  },

  sendWelcomeMessage(id) {
    return api.get(`user/${id}/welcome-message`);
  },

  updateUser(id, updates) {
    return new Promise((resolve, reject) => {
      api
        .put(`user/${id}`, { updates })
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  }
};
